import { udExpiringLocalStorage } from '@udemy/shared-utils';
export function setupTooltipLocalStorage(tooltipType) {
  const expirationDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
  return udExpiringLocalStorage('trialTooltip', tooltipType, expirationDate);
}
//# sourceMappingURL=setup-tooltip-local-storage.js.map